import { Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "../../../i18n";
import { athenaDarkPrimaryButtonSx } from "../../layout/AthenaDialogStyles";

export interface WizardStepIntroProps {
  onContinue: () => void;
}

export default function WizardStepIntro({ onContinue }: WizardStepIntroProps) {
  const { t } = useTranslation();

  return (
    <Stack spacing={2.5}>
      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
          {t("contracts_wizard.intro.why_title", "Why this matters")}
        </Typography>
        <Typography variant="body2" color="inherit" sx={{ opacity: 0.9 }}>
          {t(
            "contracts_wizard.intro.why_body",
            "Legal compliance protects both your institution and your patients. We recommend you share the documents generated in the next steps with your ethics committee (hospitals) or compliance officer (CRO / pharmaceutical companies)."
          )}
        </Typography>
      </Box>

      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
          {t("contracts_wizard.intro.commitment_title", "Our commitment")}
        </Typography>
        <Typography variant="body2" color="inherit" sx={{ opacity: 0.9, mb: 0.5 }}>
          {t(
            "contracts_wizard.intro.commitment_processor",
            "Athena Tech acts exclusively as a data processor under your instructions. We do not claim ownership of your data."
          )}
        </Typography>
        <Typography variant="body2" color="inherit" sx={{ opacity: 0.9 }}>
          {t(
            "contracts_wizard.intro.commitment_baa",
            "All AI processing runs on dedicated Microsoft Azure instances in Europe under a Business Associate Agreement (BAA). Your data stays in the EU and is processed here."
          )}
        </Typography>
      </Box>

      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
          {t("contracts_wizard.intro.next_steps_title", "What you'll do next")}
        </Typography>
        <Typography variant="body2" color="inherit" sx={{ opacity: 0.9, mb: 0.5 }}>
          {t(
            "contracts_wizard.intro.next_step_1",
            "Institutional Agreement - Configure and sign the agreement that governs our relationship."
          )}
        </Typography>
        <Typography variant="body2" color="inherit" sx={{ opacity: 0.9 }}>
          {t(
            "contracts_wizard.intro.next_step_2",
            "Patient Consent Template - Build a consent template for your patients."
          )}
        </Typography>
      </Box>

      <Box sx={{ pt: 1 }}>
        <Button variant="contained" onClick={onContinue} sx={athenaDarkPrimaryButtonSx}>
          {t("action.next", "Next")}
        </Button>
      </Box>
    </Stack>
  );
}
